/**
 * @description 发票缺陷率
 *
 * @props {string} 
 *
 * @slot {插槽} 
 *
 */
<template>
  <div class="content">
    <div class="title">
      <div class="title-item">发票缺陷率</div>
      <div class="title-item">目标：低于5% </div>
      <div class="title-item">时间范围：{{ invoiceDefect.invoiceDefect.duration }}天</div>
      <div class="title-item">{{ invoiceDefect.invoiceDefect.timeFrameStart | convertToDate }} - {{ invoiceDefect.invoiceDefect.timeFrameEnd | convertToDate }}</div>
    </div>
    <div class="main">
      <div class="grid1" :style="{width: explain ? '10%' : '20%'}">
        <div class="rate" :class="{abnormal: !invoiceDefect.invoiceDefect.completeTarget}">{{ invoiceDefect.invoiceDefect.rate }}</div>
        <div class="col">
          <span>存在发票缺陷的订单数：</span>
          <span>{{ invoiceDefect.invoiceDefect.count }}</span>
        </div>
        <div class="col">
          <span>订单总数：</span>
          <span>{{ invoiceDefect.count }}</span>
        </div>
      </div>
      <div class="grid2" :style="{width: explain ? '50%' : '70%'}">
      </div>
      <div class="message" v-if="explain">
        <div class="message-cell" v-for="(item, index) in message" :key="index">{{ item }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { convertToDate } from "@/utils/date.util"
export default {
  props: {
    explain: {
      type: Boolean,
      default: true
    },
    invoiceDefect: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      message: [
        "发票缺陷率 (IDR) 是在发货后的一个工作日内未向亚马逊企业购买家上传发票的所有订单占亚马逊企业购买家订单总数的百分比。",
        "亚马逊企业购买家需要发票进行税务计算和财务核算。",
        "要向买家提供发票，卖家可以激活亚马逊增值税计算服务，免费让亚马逊代开发票（推荐）。或者，发票可以通过第三方解决方案提供商自动上传，也可以通过管理订单页面手动上传。",
        "我们建议卖家将发票缺陷率控制在 5% 以下，以提供良好的买家体验，但目前卖家不会因为未达到此绩效目标而受到任何处罚。"
      ],
    };
  },
  filters: {
    convertToDate(val) {
      if (!val) { return "" }
      return convertToDate(new Date(val))
    }
  },
};
</script>

<style scoped lang="scss">
.abnormal {
  color: #F56C6C !important;
}
.content {
  padding-bottom: 10px;
  .title {
    line-height: 1;
    padding: 8px 0 18px 10px;
    font-size: 12px;
    display: flex;
    color: #666;
    .title-item {
      padding-left: 12px;
      &:first-child {
        padding-left: 0;
        font-weight: bold;
      }
      &:last-child {
        padding-left: 20px;
      }
    }
  }
  .main {
    display: flex;
    .grid1 {
      width: 10%;
      padding-left: 50px;
      .rate {
        padding: 18px 0 0;
        font-size: 24px;
        font-weight: 600;
        color: #333;
      }
      .col {
        padding-top: 22px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        color: #666;
      }
    }
    .grid2 {
      width: 50%;
      padding: 0 33px 0 14px;
    }
    .message {
      width: 30%;
      font-size: 12px;
      color: #666;
      line-height: 20px;
      padding: 0 26px 0 14px;
      border-left: 1px solid #ccc;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      .message-cell {
          padding: 3px 0;
      }
    }
  }
}
</style>